export const TOUR_DATA = [
  {
    title: 'Test categories',
    text: 'Click on one of the tabs to choose a test category.',
    elementId: 'testCategories',
  },
  {
    title: 'Tests',
    text: 'Please select a test.',
    elementId: 'selectTestButton',
  },
  {
    title: 'Options',
    text: 'Feel free to change the time limit if needed!',
    elementId: 'timeLimitDropdownlist',
  },
  {
    title: 'Candidate info',
    text: 'Enter an email address and name of the candidate you want to send your tests to.',
    elementId: 'candidatesEmailInput',
    widthMultiplier: 0.1,
    arrow: 'bottom',
  },
  {
    title: 'Add more candidates',
    text: 'Click the plus symbol if you want to add another candidate.',
    elementId: 'addNewCandidateButton',
    arrow: 'bottom',
  },
  {
    title: 'Share',
    text: 'Select people to share the candidate test report(s) with.',
    elementId: 'selectColleaguesDropdownlist',
    arrow: 'bottom',
  },
  {
    title: 'Settings',
    text: 'Customize the settings according to your preferences.',
    elementId: 'customizeSettingsSection',
    widthMultiplier: 0.03,
    arrow: 'bottom',
  },
  {
    title: 'Email subject',
    text: 'Enter the subject of the email that is to be sent to the candidate(s).',
    elementId: 'emailSubjectInput',
    widthMultiplier: 0.1,
    arrow: 'bottom',
  },
  {
    title: 'Email text',
    text: 'Enter the body of the email that is to be sent to the candidate(s).',
    elementId: 'emailBodyInput',
    widthMultiplier: 0.1,
    arrow: 'bottom',
  },
  {
    title: 'Send test',
    text: 'Send the test(s) when you are ready!',
    elementId: 'sendTestButton',
    arrow: 'bottom',
  },
];
